import { ReactNode } from 'react';

// Top header container to standardize title and right-side tools

export function HeaderBar({ title, right }: { title: string; right?: ReactNode }) {
  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-evat-gold/30 bg-black">
      <h1 className="font-orbitron text-2xl text-evat-gold drop-shadow-neon">{title}</h1>
      <div className="flex items-center gap-4">{right}</div>
    </header>
  );
}

export default HeaderBar;









